import React from "react";

const MediaBody = ({ children, className = null }) => {
  return (
    <div
      className={
        className ? className + " media-body" : "media-body"
      }
    >
      {children}
    </div>
  );
};
export default MediaBody;
